import { socketsURL } from "./environment";

const appConfig = {
    socketURL: socketsURL,
}

export {
    appConfig,
}